import { render, staticRenderFns } from "./shopAdd.vue?vue&type=template&id=8e2de6a8&scoped=true&"
import script from "./shopAdd.vue?vue&type=script&lang=js&"
export * from "./shopAdd.vue?vue&type=script&lang=js&"
import style0 from "./shopAdd.vue?vue&type=style&index=0&id=8e2de6a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2de6a8",
  null
  
)

export default component.exports